var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1842_1120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 27.5,
    rx: 13.75,
    fill: "#F4F0FD",
    stroke: "#AA8AF0",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6452 11.3848H18.0645V10.0384C18.0645 8.59538 17.2901 7.26271 16.0323 6.54086C14.7745 5.81971 13.2258 5.81971 11.9679 6.54086C10.7102 7.26275 9.93565 8.59545 9.93565 10.0384V11.3848H9.35503C8.60821 11.3884 8.00437 11.9891 8 12.7305V19.6536C8.00435 20.3957 8.60819 20.9957 9.35503 21H18.645C19.3918 20.9957 19.9956 20.3957 20 19.6536V12.7305C19.9956 11.9892 19.392 11.3884 18.6452 11.3848ZM14.5808 16.1697V17.3459C14.5808 17.6647 14.321 17.9228 14.0002 17.9228C13.6794 17.9228 13.4196 17.6647 13.4196 17.3459V16.169C13.1728 15.9901 13.0284 15.7038 13.0327 15.4002C13.0327 14.8687 13.466 14.4382 14.0002 14.4382C14.5344 14.4382 14.9676 14.8687 14.9676 15.4002C14.972 15.7038 14.8276 15.9901 14.5808 16.169V16.1697ZM16.9033 11.3848H11.0971V10.0384C11.0971 9.00788 11.6501 8.05526 12.5486 7.54037C13.4471 7.02474 14.5532 7.02474 15.4517 7.54037C16.3502 8.05528 16.9033 9.00792 16.9033 10.0384V11.3848Z",
    fill: "#AA8AF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1842_1120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.9397c5a9c8bcf0b9dacb144d9787a21d.svg";
export { ForwardRef as ReactComponent };